export default __webpack_public_path__ + "7e068e5e950bf120c84cc7d11ac602df.png";